import type { DestMasterRequest, MagoMasterRequest, FormErrors } from '../types/master'

export const validateDestMaster = (data: DestMasterRequest): FormErrors => {
  const errors: FormErrors = {}

  if (!data.name || data.name.trim() === '') {
    errors.name = '宛先名は必須です'
  } else if (data.name.length > 100) {
    errors.name = '宛先名は100文字以内で入力してください'
  }

  if (data.description && data.description.length > 500) {
    errors.description = '説明は500文字以内で入力してください'
  }

  if (data.sort_num !== null && data.sort_num !== undefined) {
    if (data.sort_num < 0) {
      errors.sort_num = 'ソート番号は0以上で入力してください'
    }
    if (data.sort_num > 999999) {
      errors.sort_num = 'ソート番号は999999以下で入力してください'
    }
  }

  return errors
}

const validateRequiredFields = (data: MagoMasterRequest): FormErrors => {
  const errors: FormErrors = {}

  if (data.dest_id === undefined || data.dest_id === null || data.dest_id < 0) {
    errors.dest_id = '宛先を選択してください'
  }

  if (!data.mago_id || data.mago_id.trim() === '') {
    errors.mago_id = 'デバイスIDは必須です'
  } else if (data.mago_id.length > 50) {
    errors.mago_id = 'デバイスIDは50文字以内で入力してください'
  } else if (!/^[A-Za-z0-9_-]+$/.test(data.mago_id)) {
    errors.mago_id = 'デバイスIDは英数字、ハイフン、アンダースコアのみ使用可能です'
  }

  return errors
}

const validateOptionalStringFields = (data: MagoMasterRequest): FormErrors => {
  const errors: FormErrors = {}

  if (data.lot_id && data.lot_id.length > 50) {
    errors.lot_id = 'ロットIDは50文字以内で入力してください'
  }

  if (data.group_id && data.group_id.length > 50) {
    errors.group_id = 'グループIDは50文字以内で入力してください'
  }

  if (data.product_id && data.product_id.length > 50) {
    errors.product_id = 'プロダクトIDは50文字以内で入力してください'
  }

  if (data.sim_id && data.sim_id.length > 50) {
    errors.sim_id = 'SIM IDは50文字以内で入力してください'
  }

  return errors
}

const validateLteFields = (data: MagoMasterRequest): FormErrors => {
  const errors: FormErrors = {}

  if (data.lte_type && data.lte_type.length > 20) {
    errors.lte_type = 'LTE種別は20文字以内で入力してください'
  }

  if (data.lte_plan && data.lte_plan.length > 50) {
    errors.lte_plan = 'LTEプランは50文字以内で入力してください'
  }

  if (data.lte_apn && data.lte_apn.length > 100) {
    errors.lte_apn = 'APNは100文字以内で入力してください'
  }

  return errors
}

const validateStatus = (data: MagoMasterRequest): FormErrors => {
  const errors: FormErrors = {}

  if (data.status !== undefined && data.status !== null) {
    if (![0, 1, 2, 9].includes(data.status)) {
      errors.status = '無効なステータスです'
    }
  }

  return errors
}

export const validateMagoMaster = (data: MagoMasterRequest): FormErrors => {
  return {
    ...validateRequiredFields(data),
    ...validateOptionalStringFields(data),
    ...validateLteFields(data),
    ...validateStatus(data),
  }
}

export const hasErrors = (errors: FormErrors): boolean => {
  return Object.keys(errors).length > 0
}

export const getErrorMessage = (errors: FormErrors, field: string): string | undefined => {
  return errors[field]
}
